<template>
  <v-ons-modal
    class="search-modal desktop-modal"
    :visible="showSearchScreen"
    :options="{ animation: animation }"
    @click="detectOutsideClick"
  >
    <div class="content" style="margin-top: 0px !important;">
      <div v-if="!showDetail">
        <modal-header2 title="お店を探す" @closeClicked="closeModal">
        </modal-header2>

        <div class="modal-body">
          <div class="condition-content" style="text-align: center;">
            <div class="title">
              <button style="background-color: #fff;" @click="initMode"><img :src="mapSearch" style="max-width: 100%;" /></button>
            </div>
          </div>
          <div class="condition-content">
            <div style="position:relative;">
              <div class="title" style="position:absolute;top:-2px;"><img :src="titleSearch" style="margin-left:20px;" /></div>
              <div class="title" style="border-bottom:1px solid #000;margin-bottom:12px;"></div>
            </div>
          </div>
          <div class="condition-content">
            <div
              :class="`title border-bottom icon-collapse ${
                isAreaOpen ? 'is-open' : ''
              }`"
              @click="isAreaOpen = !isAreaOpen"
            >
              地域で絞り込み
            </div>
            <area-refine></area-refine>
          </div>

          <div class="condition-content">
            <div class="title border-bottom">店名・業種で絞り込み</div>
            <name-industry-refine
              @searchRequested="submit"
            ></name-industry-refine>
          </div>

          <div class="condition-content">
            <div class="title border-bottom">サービスで絞り込み</div>
            <div class="checkbox-item">
              <label class="label" for="checkbox">
                テイクアウトができるお店
                <input
                  type="checkbox"
                  id="checkbox"
                  :checked="takeOut"
                  @change="takeOutChanged(!takeOut)"
                />
                <span class="checkmark"></span>
              </label>
            </div>

            <div class="checkbox-item">
              <label class="label" for="checkbox2">
                デリバリーができるお店
                <input
                  type="checkbox"
                  id="checkbox2"
                  :checked="delivery"
                  @change="deliveryChanged(!delivery)"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="condition-content">
            <div class="title border-bottom">地域振興ポイントで絞り込み</div>
            <coupon-refine></coupon-refine>
          </div>

          <loading v-if="searchLoading" />
        </div>

        <div class="modal-footer">
          <button class="btn btn-search" :disabled="!canSearch" @click="submit">
            この条件で検索
          </button>
          <button
            class="btn btn-cancel"
            :disabled="!canSearch"
            @click="resetPressed"
          >
          <!-- <button
            class="btn btn-cancel"
            :disabled="!cancellable"
            @click="resetPressed"
          > -->
            検索を解除
          </button>
        </div>
      </div>

      <div v-else>
        <shop-details
          :shopId="selectedShopId"
          :shop="selectedShop"
          @closeClicked="closeModal"
        ></shop-details>
      </div>
    </div>
  </v-ons-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import ModalHeader2 from "../ModalHeader2"
import NameIndustryRefine from "./NameIndustryRefine"
import AreaRefine from "./AreaRefine"
import CouponRefine from "./CouponRefine"
import detectOutsideClick from "../../mixins/detectOutsideClick"
import MapSearch from "../../assets/map-search.svg"
import TitleSearch from "../../assets/search-title.svg"

export default {
  data() {
    return {
      showDetail: false,
      selectedShopId: null,
      selectedShop: null,
      isEntered: true,
      search: null,
      isAreaOpen: false,
      isCouponOpen: false,
      mapSearch: MapSearch,
      titleSearch: TitleSearch
    }
  },

  methods: {
    selectShop(shop) {
      this.selectedShopId = shop.id
      this.selectedShop = shop
      this.showDetail = true
    },

    submit() {
      if (!this.canSearch) {
        return
      }

      this.setCancellable(true)

      document.activeElement.blur()
      this.searchMerchants()
    },

    clearPressed() {
      this.searchTextChanged("")
      this.exitSearchMode()
    },

    resetPressed() {
      this.resetAll()
      this.exitSearchMode()
    },

    initMode() {
      this.closeModal()
      this.resetAll()
      this.$emit('userLocationClicked')
      this.exitSearchMode()
    },

    ...mapActions("stores", ["searchMerchants", "sortedShops"]),
    ...mapActions("nav", [
      "closeModal",
      "exitSearchMode",
      "requestShopListScreen"
    ]),
    ...mapActions("search", [
      "resetAll",
      "searchTextChanged",
      "takeOutChanged",
      "deliveryChanged",
      "setCancellable"
    ])
  },

  computed: {
    animation() {
      return window.innerWidth > 900 ? "fade" : "lift"
    },

    ...mapGetters("stores", ["searchLoading", "searchEmpty"]),
    ...mapGetters("nav", [
      "showSearchScreen",
      "showShopListScreen",
      "showSearchResultsScreen"
    ]),
    ...mapGetters("search", ["canSearch", "cancellable", "takeOut", "delivery"])
  },

  watch: {
    showSearchResultsScreen(value) {
      if (value) {
        this.requestShopListScreen()
      }
    }
  },

  mixins: [detectOutsideClick],

  components: {
    ModalHeader2,
    NameIndustryRefine,
    AreaRefine,
    CouponRefine
  }
}
</script>

<style src="./SearchModal.scss" lang="scss"></style>
